// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios";


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

/* eslint-disable no-new */
new Vue({
  el: '#app',router,
  components: { App },
  template: '<App/>'
})

axios.defaults.baseURL = "https://vip.zhych.run" + process.env.API_BASE
const token = window.localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = token;
}
Vue.prototype.$addr = axios;

//添加响应拦截器
axios.interceptors.response.use(
  (res) => { // 成功的请求返回处理
    console.log(res)
      if(res.data.code == '10003'){
        router.push({
          path: '/login'
      })
      }else{
          return res;
      }
  },
  (err) => { // 异常的请求返回处理
      return Promise.reject(err)
  }
);


// WEBPACK FOOTER //
// ./src/main.js